const taskMessages = {
  en: {
    task: 'Task',
    tasks: 'Tasks',
    addTask: 'Add task',
    editTask: 'Edit task',
    deleteTask: 'Delete task',
    taskName: 'Task name',
    taskStatus: 'Task status',
    taskDescription: 'Task description',
    taskCreated: 'Task created',
    taskUpdated: 'Task updated',
    taskDeleted: 'Task deleted',
    taskStatusTodo: 'Todo',
    taskStatusInProgress: 'In progress',
    taskStatusDone: 'Done',
    taskStatusCanceled: 'Canceled',
    completedTasks: 'Completed Tasks',
    pendingTaskCreation: 'Pending Task Creation',
    createdOn: 'Created On',
    'tasks.schedule.carCount': 'Every {carCount, plural, one {car} other {{carCount} cars}}',
    'tasks.schedule.noCarCount': '*Add valid repeat interval',
    'tasks.schedule.onceAt': 'Once at {carCount} cars',
    'tasks.schedule.onetime': 'One time only',
    'tasks.schedule.hourly': 'Hourly',
    'tasks.schedule.daily':
      '{intervalCount, plural, one {Daily} other {Every {intervalCount} days}}',
    'tasks.schedule.weekly': 'Weekly on {weekdays}',
    'tasks.schedule.weekly.noSchedule': 'Weekly',
    'tasks.schedule.monthly':
      '{intervalCount, plural, one {Monthly on {date}} other {Every {intervalCount} months on the {date}}}',
    'tasks.schedule.monthly.sameweekday': 'the first {day}',
    'tasks.schedule.monthly.sameweekday':
      '{intervalCount, plural, one {Annually on {date}} other {Every {intervalCount} years on {date}}}',

    'tasks.schedule.yearly':
      '{intervalCount, plural, one {Annually on {date}} other {Every {intervalCount} years on {date}}}',
    maintenanceTasks: 'Maintenance Tasks',
    allMaintenance: 'All Maintenance',
    projectTasks: 'Project Tasks',
    addWorkOrder: 'Add Work Order',
    myProjectList: 'My Project List',
    assignee: 'Assignee',
    addNewProject: 'Add New Project',
    addNewWorkOrder: 'Add New Work Order',
    projectInformation: 'Project Information',
    additionalProjects: 'Additional Projects',
    projectName: 'Project Name',
    workOrderName: 'Work order name...',
    workOrder: 'Work Order',
    createWorkOrder: 'Create Work Order',
    searchWorkOrders: 'Search work orders...',
    tabToSave: 'Tab to save',
    selectMember: 'Select member...',
    projectDetails: 'Project Details',
    details: 'Details',
    dateCreated: 'Date Created',
    allTasks: 'All Tasks',
    todaysTasks: "Today's Tasks",
    todayChecklist: "Today's Maintenance Tasks",
    masterTasks: 'Master Tasks',
    essentialTasks: 'Essential Tasks',
    addMasterTask: 'Add Master Task',
    addEssentialTask: 'Add Essential Task',
    masterTask: 'Master task',
    openChecklist: 'Open Checklist',
    closingChecklist: 'Closing Checklist',
    cleaningList: 'Cleaning List',
    hourlyInspection: 'Hourly Inspection',
    hourlyInspections: 'Hourly Inspections',
    expressInterior: 'Express Interior',
    redirectToTodaysTasks: 'This task can already be completed in the "Today\'s tasks" list.',
    completeTaskAOT: 'Complete task ahead of time',
    willSkipNextTime: 'This will complete the task and skip the next scheduled time.',
    willUpdateCarCountTask:
      'This will complete the task and update the number of cars the task should be completed at.',
    editMasterTask: 'Edit Master Task',
    editEssentialTask: 'Edit Essential Task',
    archiveTask: 'Archive Task',
    taskArchiveConfirmation: 'Are you sure you want to archive task: {name}?',
    taskCompletionConfirmation: 'Are You Sure You Want To Complete {count} task(s)?',
    taskSnoozeConfirmation: 'Are You Sure You Want To Snooze {count} task(s)?',
    snoozeTask: 'Snooze Task',
    completeTask: 'Complete Task',
    editTaskDetails: 'Edit Task Details',
    completeTaskAnyway: 'Complete Task Anyway',
    taskDependenciesPresent: 'Task Dependencies Present',
    taskDependenciesDescription:
      'The task(s) you are trying to complete include dependencies. Please finalize them prior to completing the selected task(s).',
    viewDependencies: 'View Dependencies',
    taskCompletion: 'Task Completion',
    taskUnlinkConfirm: 'Remove link to {name}?',
    removeLink: 'Remove link',
    taskUnlinkDescription: 'You can go back and relink the task later',
    info: 'Info',
    confirmTaskCompletion: 'Confirm Task Completion(s)',
    confirmTaskCompletionDescription: 'Please confirm the completion of the following task(s):',
    confirmTaskSnooze: 'Snooze Task(s)',
    confirmTaskSnoozeDescription: 'Please confirm the snoozing of the following task(s):',
    taskDetails: 'Task Details',
    taskLocation: 'Task Location',
    taskType: 'Task Type',
    snooze: 'Snooze',
    unsnooze: 'Unsnooze',
    snoozeTask: 'Snooze Task',
    blockTask: 'Block Task',
    preventativeMaintenance: 'Preventative Maintenance',
    toggleFullTask: 'Toggle Full-Width Task',
    taskOptions: 'Task Options',
    collapseTask: 'Collapse Task',
    newTaskDetails: 'Enter New Task Details',
    taskSubTitle: 'Task Subtitle',
    linkedTasks: 'Linked Tasks',
    linkTasksTogether: 'Link Tasks Together',
    instructions: 'Instructions',
    linkTasksInstructions:
      'Select the link type, then search for the task you are trying to link. You can link any amount of tasks by ‘has to be completed before, blocked by and is related to. ',
    linkTasks: 'Link Tasks',
    selectDependency: 'Search for a dependency',
    selectTask: 'Search for a task to link too ...',
    blockedBy: 'is blocked by',
    doneBefore: 'has to be done before',
    doneAfter: 'has to be done after',
    thisTaskHasToBeDoneBefore: 'This has a task that has to be done before ',
    theseTasksHaveToBeDoneBefore: 'These tasks have to be done before ',
    addNewTask: 'Add New Task',
    estimatedDueDate: 'Estimated Due Date',
    completeTaskTitleText: 'Click to complete task',
    uncompleteTaskTitleText: 'Click to uncomplete task',
    due: 'Due',
    dueByTime: 'Due by {time}',
    dueBeforeTime: 'Due before {time}',
    estimatedTime: 'Estimated {time}',
    dueAtCars: 'Due at {carCount} cars',
    doneAtTime: 'Done {time}',
    doneAtCars: 'Done at {carCount} cars',
    viewTaskDetails: 'View task details',
    all: 'All',
    opening: 'Opening',
    daily: 'Daily',
    closing: 'Closing',
    hourly: 'Hourly',
    hourlyChecklist: 'Hourly Checklist',
    walkthroughChecklist: 'Walkthrough Checklist',
    noTasksFound: 'No tasks found.',
    hourlyTasksMissing: 'Task list will populate shortly.',
    createNewLinked: 'Create new linked project after blocking',
    enterSnoozeReason: 'Please enter a reason for snoozing:',
    monthly: 'Monthly',
    biWeekly: 'Bi-Weekly',
    weekly: 'Weekly',
    monthAhead: 'Month Ahead',
    enterBlockReason: 'Please enter a reason for blocking:',
    block: 'Block',
    unblock: 'Unblock',
    dueToday: 'Due today',
    dueWithinTheWeek: 'Due within the week',
    addAnotherAfterSave: 'Add another after save',
    estimatedCapacity: 'Estimated Capacity',
    estimatedTime: 'Estimated Time',
    clear: 'Clear',
    noCompletedTasks: 'No completed tasks',
    completedMaintenanceTasks: 'Completed Maintenance Tasks',
    collapseCompleted: 'Collapse Completed Maintenance Tasks',
    later: 'Later',
    thisWeek: 'This Week',
    nextWeek: 'Next Week',
    overdue: 'Overdue',
    today: 'Today',
    tomorrow: 'Tomorrow',
    calendar: 'Calendar',
    checklist: 'Checklist',
    noNotes: 'No notes',
    walkthrough: 'Walkthrough',
    last30: 'Last 30 Days',
    dueIn: 'Due In',
    dueInDays: 'Days Until Due',
    updated: 'Updated',
    blocked: 'Blocked',
    addWorkOrder: 'Add Work Order',
    newWorkOrderPlaceholder: 'New work order…',
    addDetailsPlaceholder: 'Add details…',
    addInstructionsPlaceholder: 'Add instructions…',
    dateCreated: 'Date Created',
    notAdded: 'Not added',
  },
};

export default taskMessages;
